/*
  File: src/index.js
  Purpose: Application entry point; mounts React tree, provides context providers, and configures routes.
  Responsibilities:
  - Wrap app with `AuthProvider` and `CartProvider` and the router.
  - Define protected routes and auth-redirect routes.
  - Best-effort cart sync on pagehide/beforeunload via `AuthedNav`.
*/
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
